import styled from '@emotion/styled';
import { Klaviyo } from '@innovationdepartment/proxima-ui';

const KlaviyoIconSmallWrapper = styled.div<{ active: boolean }>`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 2px;

  ${({ active }) => {
    if (active) return '';

    return `
      & :is(svg, path) {
        opacity: 0.4;
      }
    `;
  }}
`;

const KlaviyoIcon = ({ active }: { active?: boolean }) => (
  <KlaviyoIconSmallWrapper active={!!active}>
    <Klaviyo />
  </KlaviyoIconSmallWrapper>
);

export default KlaviyoIcon;
